module.exports = __webpack_public_path__ + "img/15.35b1001f.jpg";